export default {
  common: {
    hideCbtEvents: 'common.cbtEvents.hide',
    showRedirectModal: 'common.redirectModal.showRedirectModal',
  },
  homepage: {
    ukCmaFeatures: 'homepage.showUKcmaFeatures',
  },
};
